export default "__VITE_ASSET__95635b30__"